import React from "react";
import PropTypes from "prop-types";

import SearchBar from "../Shared/SearchBar";

import { adjective as proAdjective, verb as proVerb } from "@language/provider";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Navigation from "@components/Global/Custom/Navigation";
import shortid from "shortid";
import useStyles from "@hooks/useStyles";

const StateBanner = ({ state }) => {
	const classes = useStyles("State");

	return (
		<React.Fragment>
			<section className={classes.wrapper}>
				<Box
					width="100%"
					left={0}
					top="50%"
					pr={2}
					pl={2}
					className={classes.heroBox}
				>
					<Container maxWidth={false} style={{ maxWidth: 760 }}>
						<h1 className={classes.mainH1}>
							{`Find ${proAdjective.plural} in ${state.name
								.toLowerCase()
								.ucFirst()}`}
						</h1>
						<Box color={"grey.700"} mb={4} fontSize={{ xs: 16, sm: 18 }}>
							{`Find expert ${proAdjective.plural} for local and online ${
								proVerb.singular
							} in ${state.name.toLowerCase().ucFirst()}.`}
						</Box>

						<div>
							<SearchBar searchPlaceHolder={"What service do you need?"} />
						</div>
					</Container>
				</Box>
			</section>
		</React.Fragment>
	);
};

StateBanner.propTypes = {
	state: PropTypes.shape({
		name: PropTypes.string.isRequired,
	}).isRequired,
};

export default StateBanner;
